import { render, staticRenderFns } from "./financialRecord.vue?vue&type=template&id=36a4052c&scoped=true&"
import script from "./financialRecord.vue?vue&type=script&lang=js&"
export * from "./financialRecord.vue?vue&type=script&lang=js&"
import style0 from "./financialRecord.vue?vue&type=style&index=0&id=36a4052c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a4052c",
  null
  
)

export default component.exports